const customersSearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "R_CUSTOMER",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Customer:",
                "type": "select",
                "options": [""],
                "apiUrl": "om/SaleOrder/GetCustomers",
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "City",
                "tableName": "City",
                "label": "City",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Name",
                "tableName": "Name",
                "label": "Name",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "State",
                "tableName": "State",
                "label": "State",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "Address1",
                "tableName": "Address1",
                "label": "Address1",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "Zip",
                "tableName": "Zip",
                "label": "Zip",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "Address2",
                "tableName": "Address2",
                "label": "Address2",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "Tel",
                "tableName": "Tel",
                "label": "Tel",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            }
        ]
    }
];
export default customersSearchFormLayout;